/**
 * 兼容gk得loginInfo模式
 * 
 * loginInfo 格式：
 * {
    "access_token": "p37cslih3y65gy2excqdcfm1gjwi7rvmmb34wbpr",
    "expires_in": 1689260935,
    "scope": "default",
    "token_type": "Bearer",
    "refresh_token": "1vdeael1z4sixzbkggf5k4tayy4jixrivah0i46b",
    "code": 0,
    "msg": ""
    }
 */
import Cookie from '@/utils/cookie.js'

/**
 * token 和 uid 尽量同时set，某些接口会要求同时传递
 * @param {LoginInfo} loginInfo 格式参考上面
 */
export const setLocalToken = (loginInfo = '') => {
  localStorage['loginInfo'] = JSON.stringify(loginInfo)
  Cookie.setCookie("access_token",  loginInfo.access_token, 30, ';domain=gaokaozhitongche.com') // 兼容未来gaokaozhitongche主域名的页面登录
}

export const getLocalToken = () => {
  return localStorage['loginInfo'] ? JSON.parse(localStorage['loginInfo']) : ''
}

export const getCookieToken = () => {
  return Cookie.getCookie("access_token")
}

export const getCookieUid = () => {
  return Cookie.getCookie("user_id")
}

/**
 * uid
 * @param {*} uid 
 */
export const setLocalUid = (uid = '') => {
  localStorage['uid'] = uid
  Cookie.setCookie("user_id",  uid, 30, ';domain=gaokaozhitongche.com') // 兼容未来gaokaozhitongche主域名的页面登录
}

export const getLocalUid = () => {
  return localStorage['uid'] ? localStorage['uid'] : ''
}

/**
 * openid
 * @param {*} openid 
 */

export const setLocalOpenId = (openid = '') => {
  Cookie.setCookie("openId",  openid) // 兼容未来gaokaozhitongche主域名的页面登录
}

export const getLocalOpenId = () => {
  return Cookie.getCookie('openId')
}

// 全部清除
export const clearLocalToken = () => {
  localStorage.removeItem('loginInfo')
  localStorage.removeItem('uid')
  Cookie.clearCookie("access_token", ';domain=.gaokaozhitongche.com') 
}

    